import ReactDOM from 'react-dom/client'
import 'bootstrap/dist/css/bootstrap.css'
import App from './App'

ReactDOM.createRoot(document.getElementById('root')!).render(<App />)
